document.addEventListener("DOMContentLoaded", () => {
  let processed = false;
  let attempts = 0;
  const maxAttempts = 10; // 10 times
  const checkInterval = 200; // 200ms interval

  function checkForForm() {
    if (attempts >= maxAttempts) return; // Exit after 10 attempts (2 seconds)

    attempts++;
    var formEm = document.querySelector('form-embed');
    if(formEm) {
        callbackFunction();
    } else {
      setTimeout(checkForForm, checkInterval);
    }
  }

  setTimeout(checkForForm, 1200); // Keep your initial delay

  function callbackFunction() {
    if (processed) return;

    var formEm = document.querySelector('form-embed');
    if(formEm && formEm.shadowRoot) { // check shadowRoot exists
      processed = true; // set flag

      const isILDStore = window.dooneyStoreName === 'ild';
      const desktopFont = isILDStore
        ? 'normal 600 40px Poppins, Verdana, Geneva, Tahoma, sans-serif'
        : 'normal 600 40px BemboStd, serif';

      const mobileFont = isILDStore
        ? 'normal 600 32px Poppins, Verdana, Geneva, Tahoma, sans-serif'
        : 'normal 600 32px BemboStd, serif';

      const styleFunction = document.createElement("style");
        styleFunction.textContent =
          `:host {
            --inline-container-max-width: 99%;
            --forms-heading-font-size: 40px;
            --forms-heading-font: ${desktopFont};
            --form-heading-margin-bottom: 48px;
            --form-field-border: none;
            --form-input-border: 1px solid rgba(0,0,0,0.2);
            --form-field-border-focused: 0 0 0 2px #000;
            --forms-accent-color: #000;
            --container-text-alignment: center;
            @media (max-width:768px) {
              --forms-heading-font: ${mobileFont};
              --form-heading-margin-bottom: 24px;
              --form-field-border: none;
              --form-field-border-focused: 0 0 0 2px #000;
            }
           }
           h2 {
            line-height: 100% !important;
            margin-bottom: var(--form-heading-margin-bottom) !important;
           }
           input,textarea,select {
            border: var(--form-input-border) !important;
           }
            [class*="_checkboxFieldSet"] legend { display:none;}
            form {
              gap:0 !important;
              row-gap:15px !important;
            }
           `;
        var shadowData = formEm.shadowRoot;
        shadowData.appendChild(styleFunction);
        if(shadowData.querySelectorAll('[type="checkbox"]')) {
          shadowData.querySelectorAll('[type="checkbox"]')[0].checked = true;
        }
    }else if (!processed) { // Only change: add !processed check
      setTimeout(callbackFunction, 500);
    }
  }
});